import corporateRequest from 'utils/corporateRequest'
import corporateSelector from 'modules/Auth/selectors'
import ErrorMessage from 'components/UIComponents/MessagePopup/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import elasticSearchRequest from 'utils/elasticSearchRequest'
import elasticSearchSyncRequest from 'utils/elasticSearchSyncRequest'

export const SET_CORPORATE_LOCATIONS_LIST =
  'corporate/SET_CORPORATE_LOCATIONS_LIST'
export const SET_SINGLE_LOCATIONS = 'corporate/SET_SINGLE_LOCATIONS'

export const setCorporateLocationsList = data => {
  return {
    type: SET_CORPORATE_LOCATIONS_LIST,
    data,
  }
}

export const setSingleLocation = data => {
  return {
    type: SET_SINGLE_LOCATIONS,
    data,
  }
}

export const getCorporateLocationsList =
  ({ pageLimit = 10, currentPage = 1, setLoading }) =>
  async (dispatch, getState) => {
    const state = getState()
    const corporateId = corporateSelector.getCorporateId(state)
    try {
      setLoading(true)
      let response = await corporateRequest.get(
        `/corporates/${corporateId}/branch?currentPage=${currentPage}&pageLimit=${pageLimit}`
      )
      dispatch(setCorporateLocationsList(response?.data?.data))
      setLoading(false)
      return response
    } catch (error) {
      console.error('Error in getting corporate locations list', error)
      setLoading(false)
      ErrorMessage(error?.response?.data?.message)
      return error
    }
  }

export const addCorporateBranch =
  ({ payload }) =>
  async (dispatch, getState) => {
    const state = getState()
    const corporateId = corporateSelector.getCorporateId(state)
    try {
      let response = await corporateRequest.post(
        `/corporates/${corporateId}/branch`,
        payload
      )
      function formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
      
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
      
        return [year, month, day].join('-');
      }
  
   
        let payloadData = {
          query_date: formatDate(new Date())  // This will format today's date as "yyyy-mm-dd"
        };
  
      elasticSearchSyncRequest.post(`/sync/corporate_list`,payloadData)
      SuccessMessage('Added successfully.')
      return response
    } catch (error) {
      console.error('Error in adding corporate location.', error)
      ErrorMessage(error?.response?.data?.message)
      return error
    }
  }

export const getLocationDetails = locationId => async (dispatch, getState) => {
  try {
    let response = await corporateRequest.get(
      `/corporates/branch/${locationId}`
    )
    dispatch(setSingleLocation(response?.data?.data || {}))
    return response
  } catch (error) {
    console.error('Error in getting corporate location details', error)
    ErrorMessage(error?.response?.data?.message)
    return error
  }
}

export const deleteLocationAPI =
  ({ locationId }) =>
  async (dispatch, getState) => {
    try {
      let response = await corporateRequest.delete(
        `/corporates/branch/${locationId}`
      )
      function formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
      
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
      
        return [year, month, day].join('-');
      }
  
   
        let payloadData = {
          query_date: formatDate(new Date())  // This will format today's date as "yyyy-mm-dd"
        };
  
      elasticSearchSyncRequest.post(`/sync/corporate_list`,payloadData)
      SuccessMessage('Deleted Successfully.')
      return response
    } catch (error) {
      console.error('Error in deleting corporate location', error)
      ErrorMessage(error?.response?.data?.message)
      return error
    }
  }

export const updateLocationAPI =
  ({ locationId, payload }) =>
  async (dispatch, getState) => {
    const state = getState()
    const corporateId = corporateSelector.getCorporateId(state)
    try {
      let response = await corporateRequest.put(
        `/corporates/${corporateId}/branch/${locationId}`,
        payload
      )
      function formatDate(date) {
        let d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();
      
        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;
      
        return [year, month, day].join('-');
      }
  
   
        let payloadData = {
          query_date: formatDate(new Date())  // This will format today's date as "yyyy-mm-dd"
        };
  
      elasticSearchSyncRequest.post(`/sync/corporate_list`,payloadData)
      SuccessMessage('Updated Successfully.')
      return response
    } catch (error) {
      console.error('Error in getting updating location details', error)
      ErrorMessage(error?.response?.data?.message)
      return error
    }
  }
